import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'class-names';
import 'currency-flags/dist/currency-flags.css';
import CurrencyFlagCircularStyle from './CurrencyFlag.styles';
import style from './DefaultCountryFlag.module.less';
import currencyFlagsList from './currencyFlagsList';

const hasStyle = (name) => {
  return currencyFlagsList.includes(name.toLowerCase());
};

const CurrencyFlag = ({ currencyName }) => {
  const flag = hasStyle(currencyName) ? `currency-flag-${currencyName.toLowerCase()}` : style.defaultFlag;
  return <div className={classNames('currency-flag', flag)} />;
};

const CurrencyFlagCircular = ({ currencyName, ...props }) => (
  <CurrencyFlagCircularStyle {...props}>
    <CurrencyFlag currencyName={currencyName || ''} />
  </CurrencyFlagCircularStyle>
);

CurrencyFlag.propTypes = {
  currencyName: PropTypes.string.isRequired,
};

export { CurrencyFlag, CurrencyFlagCircular };
